<!-- <button
    mat-button
    [matMenuTriggerFor]="organisationMenu"
    class="h-40 min-h-40 w-full px-4 text-left"
>
    <div class="flex items-center">
        <span class="truncate">
            @if (currentOrganisation$ | async; as currentOrg) {
                {{ currentOrg.name }}
            } @else {
                Select Organisation
            }
        </span>
        <mat-icon
            class="ml-2"
            [svgIcon]="'heroicons_solid:chevron-down'"
        ></mat-icon>
    </div>
</button>

<mat-menu #organisationMenu="matMenu">
    @if (organisations$ | async; as organisations) {
        @for (organisation of organisations; track organisation.id) {
            <button
                mat-menu-item
                (click)="switchOrganisation(organisation)"
            >
                <span>{{ organisation.name }}</span>
            </button>
        }
    }
</mat-menu>  -->


<div [matMenuTriggerFor]="organisationMenu">
    <organisation-name [organisation]="organisation" [size]="OrganisationNameSize.LARGE" showState="true"></organisation-name>
</div>

<mat-menu [xPosition]="'before'" #organisationMenu="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Your Organisation</span>
            <span class="mt-1.5 text-md font-medium">{{ organisation.name }}</span>
        </span>
    </button>
    <ng-container *ngIf="userRole?.name === 'ADMIN'">
        <mat-divider class="my-2"></mat-divider>
        <button  mat-menu-item (click)="gotoSettings('settings')">
            <mat-icon
            [svgIcon]="'heroicons_outline:ellipsis-horizontal-circle'"
        ></mat-icon>
            <span>Settings</span>
        </button>
    </ng-container>
    <mat-divider class="my-2"></mat-divider>
    <button *ngIf="organisations.length === 1" mat-menu-item (click)="createNewOrganisation()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Create New Organisation</span>
    </button>
    <button *ngIf="organisations.length > 1" mat-menu-item [matMenuTriggerFor]="switchOrganisationMenu">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Switch Organisations</span>
    </button>
</mat-menu>

<mat-menu class="organisation-settings-menu" #switchOrganisationMenu="matMenu">
    @for (organisation of organisations; track organisation.uuid) {
        <button mat-menu-item (click)="switchOrganisation(organisation)">
            <organisation-name [organisation]="organisation" [size]="OrganisationNameSize.SMALL"></organisation-name>
        </button>
    }
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="createNewOrganisation()">
        <mat-icon
            [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"
        ></mat-icon>
        <span>Create New Organisation</span>
    </button>
    <!-- <button mat-menu-item (click)="gotoSettings('account')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-green-500"></span>
        <span>Account</span>
    </button>
    <button mat-menu-item (click)="gotoSettings('security')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-amber-500"></span>
        <span>Security</span>
    </button>
    <button mat-menu-item (click)="gotoSettings('plan')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-red-500"></span>
        <span>Plan & billing</span>
    </button>
    <button mat-menu-item (click)="gotoSettings('notifications')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Notifications</span>
    </button>
    <button mat-menu-item (click)="gotoSettings('members')">
        <span class="mr-3 inline-flex h-4 w-4 rounded-full bg-gray-400"></span>
        <span>Members</span>
    </button> -->
</mat-menu>
<!-- {{ organisation | json }} -->